import { quotationPdfApi } from "../../api";

const QuotationPdfService = {
    /**
     * 📄 Descarga o visualiza
     * el PDF de cotización
     *
     * GET /api/pdf/quotations/{id}
     */
    download: async (
        id: number
    ): Promise<{
        blob: Blob;
        fileName: string | null;
    }> => {

        const response =
            await quotationPdfApi.fetchBlob(
                `/${id}`
            );

        return {
            blob: response.data,

            fileName:
                response.fileName ||
                `cotizacion_${id}.pdf`,
        };
    },
};

export default QuotationPdfService;